<script setup lang="ts">
  import {RouterLink} from "vue-router";
  import {Model} from "@/app/Model";

  let model: Model = Model.getReactiveInstance();

  declare let gtagO: Function;
  declare let frontendConfig: any;

  function setgtagO(filter: string): void {
    switch (filter) {
      case 'Dejure':
        gtagO({
          event: 'outboundlink', 
          target: 'http://www.dejure.it',
          posizione: 'top Percorso'
        })

        break;
      case 'nuova':
        gtagO({
          event: 'Nuova ricerca'
        })

        break;
      case 'Dashboard':
        gtagO({
          event: 'link dashboard', 
          posizione: 'top Percorso',
          percorso: 'Responsabilita'
        })
    }
  }

  function isRebranding(): boolean {
    return frontendConfig.rebranding;
  }
</script>

<template>
  <div class="container-fluid border-bottom testata">
    <div class="row ">
      <div class="col-md-4 col-12 p-3">
        <RouterLink to="/">
          <img v-if="!isRebranding()" alt="Home" class="logo" src="../../assets/logo.svg" />
          <img v-if="isRebranding()" alt="Home" class="logo" src="../../assets/LOGO_STRATEGIA.png" />
        </RouterLink>
      </div>

      <div class="col-md-6 col-8 p-4 px-1 text-center testataButtons">
        <RouterLink to="/" class="btn btn-error" @click="setgtagO('nuova')">
          <i class="bi bi-calculator"></i> &nbsp; Nuova ricerca
        </RouterLink>
        &nbsp;
        <RouterLink to="/responsabilita/dashboard" class="btn btn-error" @click="setgtagO('Dashboard')">
          <i class="bi bi-graph-up"></i> &nbsp; Vai alla Dashboard
        </RouterLink>
        &nbsp;
        <RouterLink to="/admin" class="btn btn-error" v-if="model.isAdmin"><i class="bi bi-pen"></i> &nbsp; Admin</RouterLink>
      </div>
      <div class="col-md-2 col-4 text-right p-4 px-2">
        <a class="btn btn-primary" href="http://www.dejure.it" target="_blank" @click="setgtagO('Dejure')">Vai a Dejure</a>
      </div>
    </div>
  </div>
</template>